import { ApiError } from '@api/client'
import { useI18n } from '@i18n/I18nProvider'
import { Icon } from '@ui/Icon'
import { Screen } from '@ui/Screen'
import { ErrorState, LoadingState } from '@ui/States'
import { useSearch } from 'wouter'
import { channelFromSearch } from './channel'
import { TreeDetails } from './TreeDetails'
import { useTree } from './useTree'

// Ficha de un árbol (spec `trees`): el destino del QR. Ligera a propósito (sin mapa) para
// abrir rápido con poca cobertura. El aviso se hace aquí mismo (paso a paso) y la especie se abre
// en una hoja, sin cambiar de pantalla (el contenido, en TreeDetails; desde el mapa, TreeSheet).
export const TreePage = ({ code }: { code: string }) => {
	const { t } = useI18n()
	const channel = channelFromSearch(useSearch())
	const { data: tree, error, isPending, refetch } = useTree(code)

	if (isPending)
		return (
			<Screen>
				<LoadingState shape="detail" />
			</Screen>
		)
	if (error instanceof ApiError && error.isNotFound)
		return (
			<Screen>
				<div role="alert" className="flex flex-col items-center gap-4 py-12 text-center">
					<Icon name="tree" className="size-12 text-earth-600" />
					<p className="text-lg">{t('tree.notFound')}</p>
				</div>
			</Screen>
		)
	if (error || !tree) return <ErrorState error={error} onRetry={() => refetch()} />

	return (
		<Screen>
			<TreeDetails tree={tree} channel={channel} />
		</Screen>
	)
}
